<template>
    <component 
        :is="tag"
        :class="className"
        @click.prevent="open"
    >
        <slot></slot>
    </component>
  
  <Teleport to="body">
    <transition name="slide-right">
    <div 
      v-if="isOpen"
      class="modal"
      ref="demo"
      id="demo"
      @click.self="close"
      @touchstart.passive="onTouchStart"
      @touchend.passive="onTouchEnd"
      @touchmove.passive="onTouchMove"
    >
   
      <div class="modal__inner">
        <div class="headline">
            <button class="headline__left" @click.prevent="close">
              <Icon name="left" />
            </button>
            <div class="headline__title">
              {{ auth && !store.isAuth ? "Вход" : title }}
            </div>
            <button class="headline__right" @click.prevent="close">
              <Icon name="xmark" />
            </button>
        </div>
        <!-- <component :is="loadComponent()" /> -->
         <template v-if="auth">
            <Auth v-if="!store.isAuth" :callback="callback" />
            <slot v-else name="content"></slot> 
         </template>
         <slot v-else name="content"></slot>
      </div>
    </div>
    </transition>
    <!-- <div class="modal-half" v-if="isHalf"></div> -->
  </Teleport>
</template>
  
<script setup>

import { ref, reactive, watch, computed, defineAsyncComponent, h } from 'vue'
import anime from 'animejs'
import Auth from '@/Components/auth/Auth.vue'
import store from '@/store'

import { useRoute } from 'vue-router'


const route = useRoute()

const emit = defineEmits();
const {
  className,
  tag = 'button',
  title,
  auth = false,
  load = null,
  modelValue = false,
  callback = null
} = defineProps([
  'modelValue',
  'tag',
  'className',
  'auth',
  'load',
  'title',
  'callback'
])


// const loadComponent = () => {
//   console.log(3333, load)
//   const asyncFile = defineAsyncComponent(() => import(`${load}.vue`))
//   return h(asyncFile, {
//     lol: 1
//   })
// } 



const isOpen = ref(false)
const isHalf = ref(false)

const open = () => {
  isOpen.value = true;
  emit('update:modelValue', true)
}
const close = () => {
  
  isOpen.value = false
  emit('update:modelValue', false)
  return

  const el = document.querySelector('#demo')

  isHalf.value = false

  anime({
    targets: el,
    translateX: 1000,
    duration: 300
  })
  
  setTimeout(() => {
    isOpen.value = false;
  }, 300);
  
}

watch(
  () => route.params,
  async () => {
    close()
  },
  {
    flush: 'post',
    immediate: true
  }
)


let startX = 0;
let currentX = 0;
let isDragging = false;

let start = [0,0]
let current = [0,0]

const onTouchStart = (event) => {
  //return;
  start[0] = event.touches[0].clientX
  start[1] = event.touches[0].clientY
  isDragging = true
  isHalf.value = true
}


const onTouchMove = (event) => {
  //return;
  if (!isDragging) return;
  const el = document.querySelector('#demo')
  currentX = event.touches[0].clientX;
  current = [event.touches[0].clientX, event.touches[0].clientY];
  const deltaX = currentX - startX;

  const delta = [
    current[0] - start[0],
    current[1] - start[1]
  ]

  console.log(333, current, start , delta)

  if (delta[0] > 100) {
    close()
  }


  return;

  // if(current[1] != start[1]) {
  //   return
  // }

  // if (delta[1] > 5 || delta[1] < -5) {
  //   return
  // }

  // if((current[1] + 10 > start[1] || current[1] - 10 > start[1])) {
  //   return;
  // }

  if (delta[0] > 0) {
    anime({
      targets: el,
      translateX: delta[0],
      duration: 0
    })
  }
}

const onTouchEnd = (event) => {
  return
  const el = document.querySelector('#demo')
  if(current[0] - start[0] > window.innerWidth / 2) {
    close()
  } else {
    current[0] = 0;
    anime({
      targets: el,
      translateX: 0,
      duration: 300
    })
  }
}
</script>

<style lang="scss">
.modal {
  z-index: 1000;
  display: flex;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  position: fixed;
  background: var(--background);

  @include mq('md') {
    background: rgba(0, 0, 0, 0.5);
  }

  &__inner {
      max-height: 100vh;
      overflow-y: scroll;
      padding: 0 var(--gutter);
      width: 100%;
      
      @include mq('md') {
        margin: auto;
        max-width: 640px;
        min-width: 400px;
        //width: fit-content;
        background: var(--background);
        padding: 15px;
        border-radius: 8px;
      }
  }
}

.modal-half {
  z-index: 900;
  top: 0;
  bottom: 0;
  left: 80%;
  right: 0;
  position: fixed;
  background: var(--background);
}


.headline {
  position: fixed;
  width: 100%;
  left: 0;
  right: 0;
  top: 0;
  border-bottom: 1px solid var(--border);
  height: 50px;
  display: flex;
  align-items: center;
  padding: 0 var(--gutter);
  z-index: 100;
  background: var(--background);

  & + .content {
    padding-top: 50px;
    @include mq('md') {
      padding-top: 20px;
    }
  }

  @include mq('md') {
    position: relative;
    padding: 0;
    margin-top: -15px;
  }

  &__left {
    display: flex;
    height: 100%;
    align-items: center;
    width: 40px;
    font-size: 24px;
    @include mq('md') {
      //display: none;
    }
  }

  &__right {
    display: flex;
    height: 100%;
    align-items: center;
    width: 40px;
    font-size: 24px;
    margin-left: auto;
    @include mq('md', 'max') {
      display: none;
    }
  }

  &__title {
    font-weight: bold;
    font-size: 18px;
    align-items: center;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
  }

  & + * {
    margin-top: 60px;
    @include mq('md') {
      margin-top: 0;
    }
  }
}

.slide-right-enter-active,
.slide-right-leave-active {
  transition: transform 0.3s ease;
  @include mq('md') {
    transition: none;
  }
}

.slide-right-enter-from {
  transform: translateX(100%);
}

.slide-right-enter-to {
  transform: translateX(0);
}

.slide-right-leave-from {
  transform: translateX(0);
}

.slide-right-leave-to {
  transform: translateX(100%);
}

.slide-display-enter-active {
  transition: display 0.2s ease;
}
.slide-display-leave-active {
  display: none;
}

.slide-display-enter-from {
  display: none;
}

.slide-display-enter-to {
  display: block;
}

.slide-display-leave-from {
  display: none;
}

.slide-display-leave-to {
  display: none;
}
</style>